// mobileAuthService.js
// Handles seamless sign-in when the mobile app opens the website with a
// Firebase custom token in the URL: /account?token=<customToken>
//
// Flow:
//   Mobile app (authenticated) → calls generateWebToken Cloud Function
//   → gets customToken → opens /account?token=customToken
//   → this service signs the user in silently → normal app flow continues

import { getAuth, signInWithCustomToken } from "firebase/auth";

const mobileAuthService = {
  /**
   * Call this once on mount in Account.jsx.
   * Reads ?token= from the URL, signs in with it, then removes it from history
   * so the token doesn't linger in the browser's address bar or history.
   *
   * Returns the signed-in user if a token was found and valid, otherwise null.
   */
  async handleTokenFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) return null;

    // Strip the token from the URL immediately so it's not left in history
    params.delete("token");
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "");
    window.history.replaceState({}, "", newUrl);

    try {
      const auth = getAuth();
      console.log("📱 [mobileAuth] Signing in with custom token from URL...");
      const credential = await signInWithCustomToken(auth, token);
      console.log("✅ [mobileAuth] Signed in as:", credential.user.uid);
      return credential.user;
    } catch (err) {
      console.error("❌ [mobileAuth] signInWithCustomToken failed:", err.message);
      // Non-fatal — fall through to normal sign-in flow
      return null;
    }
  },
};

export default mobileAuthService;
